<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: BCC Pubs
      Author: SweetAs
    Author URL: http://sweetas.xyz
========================================================================================== -->


<template>    
    <div id="knowledge-base-page">
      <div class="knowledge-base-jumbotron mt-5 mr-5 ml-5">
        <div class="knowledge-base-jumbotron-content p-8 rounded-lg mb-base">
          <div class="vx-row">
            <div class="vx-col w-5/6">
              <h1 class="mb-1 text-white text-left"> {{ sw_refid }} </h1>
            </div>
            <div class="vx-col w-1/6 text-right">
              <vs-button  icon-pack="feather" icon="icon-home" class="mr-3 mt-5"  
              @click="$router.push('/admin').catch(() => {})">Home</vs-button>
            </div> 
            <p class="text-white"> {{ sw_company }}</p>
          </div>
        </div>
      </div>      
      <div class="vx-row">
        <!-- SIMPLE CARD WITH TABS -->
        <div class="vx-col w-full mb-base">
          <vx-card>
            <vs-tabs>
              <vs-tab label="Infopoint">
                <info-point-details/> 
              </vs-tab>
              <vs-tab label="Products">
                <info-point-products/>
              </vs-tab>
              <vs-tab label="Volunteers">
                <info-point-volunteers/>
              </vs-tab>
            </vs-tabs>
          </vx-card>
        </div>
      </div>
    </div>
</template>
<script>
export default{
  components: {  },
  data () {
    return {
      sw_refid : '',
      sw_company: '',
     }
  },
  computed: { },
  mounted () {
    this.getIPDetails()
  },
  methods: { 
    getIPDetails(){      
      const payload ={ IpId: this.$route.params.id}
      this.$store.dispatch('dataList/getIpTerminalName',payload).then(d => {        
        const r =JSON.parse(d.data.data)  
        this.sw_refid = r.refid
        this.sw_company = r.company
      })
    }
  },
  created () { }
}
</script>
<style lang="scss">
.knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
}
</style>

